// extracted by mini-css-extract-plugin
module.exports = {"h1":"styles_h1__nYvNL","h2":"styles_h2__xmZM6","h3":"styles_h3__oJeUl","p":"styles_p__mqBdV","span":"styles_span__xuVQx","label":"styles_label__LmTWN"};